/**
 * rvmark-lang.js — CodeMirror binding for the engine's highlighter (rvmark/edit).
 */

import { StreamLanguage } from '@codemirror/language';
import { tags as t } from '@lezer/highlight';
import { startState, copyState, highlightLine } from 'rvmark/edit';

const TAGS = {
  bullet:      t.list,
  punctuation: t.punctuation,
  keyword:     t.keyword,
  operator:    t.operator,
  type:        t.typeName,
  variable:    t.variableName,
  property:    t.propertyName,
  string:      t.string,
  decorator:   t.annotation,
  namespace:   t.namespace,
  escape:      t.escape,
  link:        t.url,
  code:        t.monospace,
  strong:      t.strong,
  emphasis:    t.emphasis,
};

// The engine tokenizes a whole line at once; CodeMirror asks one token at a
// time, so the line's tokens are kept on the state and handed out in order.
export const rvmarkLanguage = StreamLanguage.define({
  name: 'rvmark',
  startState: () => ({ hl: startState(), tokens: [], i: 0 }),
  copyState: s => ({ hl: copyState(s.hl), tokens: s.tokens, i: s.i }),
  blankLine: s => { highlightLine('', s.hl); },
  token(stream, s) {
    if (stream.sol()) { s.tokens = highlightLine(stream.string, s.hl); s.i = 0; }
    while (s.i < s.tokens.length && s.tokens[s.i].to <= stream.pos) s.i++;
    const tok = s.tokens[s.i];
    if (!tok) { stream.skipToEnd(); return null; }
    if (tok.from > stream.pos) { stream.pos = tok.from; return null; }
    stream.pos = tok.to;
    return tok.definition ? `${tok.type}.def` : tok.type;
  },
  // CodeMirror reads `type.def` as the type's tag with `def` applied to it.
  tokenTable: { ...TAGS, def: t.definition },
});
